import {
  fullwidthGridColumn,
  grid,
  gridColumnsRoot,
  gridColumnsTablet,
} from '../../../utils/grid'
import React, { FunctionComponent } from 'react'
import Colors from '../../../tokens/Colors'
import iconFacebook from '../../../images/icon-facebook.svg'
import iconInstagram from '../../../images/icon-instagram.svg'
import iconLinkedIn from '../../../images/icon-linked-in.svg'
import iconPinterest from '../../../images/icon-pinterest.svg'
import iconWeibo from '../../../images/icon-weibo.svg'
import logoFooter from '../../../images/logo-footer.svg'
import { mediaQueries } from '../../../utils/mediaQueries'
import { rem } from '../../../utils/rem'
import { spacings } from '../../../tokens/Spacings'
import styled from 'styled-components'
import useDictionary from '../../../hooks/use-dictionary/useDictionary'

const Footer: FunctionComponent = () => {
  const dictionary = useDictionary()

  return (
    <StyledFooter>
      <Logo alt="Kvadrat Febrik" src={logoFooter} />
      <Links>
        <ExternalLink href={dictionary.get('footerKvadratUrl')}>
          {dictionary.get('footerKvadratText')}
        </ExternalLink>
        <ExternalLink href={dictionary.get('footerFebrikUrl')}>
          {dictionary.get('footerFebrikText')}
        </ExternalLink>
        <ExternalLink href={dictionary.get('footerPressKitUrl')}>
          {dictionary.get('footerPressKitText')}
        </ExternalLink>
        <ExternalLink href={dictionary.get('footerNewsletterUrl')}>
          {dictionary.get('footerNewsletterText')}
        </ExternalLink>
      </Links>
      <Socials>
        <SocialLink href={dictionary.get('socialFacebookUrl')}>
          <img alt="Facebook" src={iconFacebook} />
        </SocialLink>
        <SocialLink href={dictionary.get('socialInstagramUrl')}>
          <img alt="Instagram" src={iconInstagram} />
        </SocialLink>
        <SocialLink href={dictionary.get('socialPinterestUrl')}>
          <img alt="Pinterest" src={iconPinterest} />
        </SocialLink>
        <SocialLink href={dictionary.get('socialLinkedInUrl')}>
          <img alt="LinkedIn" src={iconLinkedIn} />
        </SocialLink>
        <SocialLink href={dictionary.get('socialWeiboUrl')}>
          <img alt="Weibo" src={iconWeibo} />
        </SocialLink>
      </Socials>
      <Copyright>
        <CopyrightLink href={dictionary.get('footerCopyrightUrl')}>
          {dictionary.get('footerCopyrightText')}
        </CopyrightLink>
      </Copyright>
    </StyledFooter>
  )
}

const StyledFooter = styled.footer`
  ${grid()};
  padding-top: ${rem(spacings.medium.root)};
  padding-bottom: ${rem(24)};

  ${mediaQueries.tablet} {
    padding-top: ${rem(spacings.medium.tablet)};
    padding-bottom: ${rem(32)};
  }

  ${mediaQueries.desktop} {
    align-items: center;
  }
`

const Logo = styled.img`
  display: block;
  width: ${rem(172)};
  height: ${rem(17)};
  margin: 0 auto ${rem(40)};
  grid-column: 1 / span ${gridColumnsRoot};
  grid-row: 1;

  ${mediaQueries.tablet} {
    margin: 0 auto ${rem(48)};
    grid-column: 1 / span ${gridColumnsTablet};
  }

  ${mediaQueries.desktop} {
    margin: 0;
    grid-column: 1 / span 6;
  }
`

const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 0 0 ${rem(48)};
  grid-column: 1 / span ${gridColumnsRoot};
  grid-row: 2;

  ${mediaQueries.tablet} {
    margin: 0 0 ${rem(56)};
    grid-column: 1 / span ${gridColumnsTablet};
  }

  ${mediaQueries.desktop} {
    justify-content: flex-end;
    grid-row: 1;
    margin: 0;
    grid-column: 11 / span 6;
  }
`

const BaseLink = styled.a.attrs({
  rel: 'noreferrer noopener',
  target: '_blank',
})`
  letter-spacing: -0.02em;
  text-decoration: none;
`

const ExternalLink = styled(BaseLink)`
  white-space: nowrap;
  margin: 0 ${rem(12)};
  font-size: ${rem(15)};
  line-height: ${rem(23)};
  color: ${Colors.SHIP_GREY};
  padding: ${rem(8)} 0;

  &:hover {
    text-decoration: underline;
  }
`

const Socials = styled(Links)`
  margin: 0;
  grid-row: 3;

  ${mediaQueries.desktop} {
    justify-content: center;
    grid-row: 1;
    grid-column: 7 / span 4;
  }
`

const SocialLink = styled(BaseLink)`
  flex: 0 0 auto;
  margin: 0 ${rem(10)};

  img {
    display: block;
    height: ${rem(24)};
    width: auto;
  }
`

const Copyright = styled.div`
  ${fullwidthGridColumn()};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${rem(16)};
  grid-row: 4;

  ${mediaQueries.tablet} {
    padding-top: ${rem(24)};
  }

  ${mediaQueries.desktop} {
    grid-row: 2;
  }
`

const CopyrightLink = styled(BaseLink)`
  display: block;
  font-size: ${rem(10)};
  line-height: ${rem(24)};
  color: ${Colors.OSLO_GREY};
  text-align: center;

  &:hover {
    text-decoration: underline;
  }
`

export default Footer
